import {SkeletonBox, SkeletonText} from '@primer/react/experimental'
import styles from './CommentContentSkeleton.module.css'

/**
 * A skeleton loader that mimics the structure of a comment thread.
 * Used as a loading state for review threads.
 */
export function CommentContentSkeleton() {
  return (
    <div data-testid="comment-content-skeleton">
      {/* Comment */}
      <div className={styles.comment}>
        <div className={styles.commentHeader}>
          <SkeletonText size="bodySmall" className={styles.authorName} />
          <SkeletonText size="bodySmall" className={styles.timestamp} />
        </div>
        <div className={styles.commentBody}>
          <SkeletonText size="bodySmall" className={styles.commentLine} />
          <SkeletonText size="bodySmall" className={styles.commentLine} />
        </div>
      </div>

      {/* Footer with replies */}
      <div className={styles.footer}>
        <SkeletonBox className={styles.repliesButton} />
      </div>
    </div>
  )
}
